import { useTranslation } from "react-i18next";
import { TestimonialsProps } from "./testimonials.types";
import { useAnalytics } from "@commons-monorepo/index";
import { useCallback, useRef, useState } from "react";
import Slider from "react-slick";
import { TESTIMONIAL_EVENTS } from "./testimonials.events";

const useTestimonials = ({
  testimonials,
  storeMetadata,
  config,
}: TestimonialsProps) => {
  const { t } = useTranslation();
  const [logEvent] = useAnalytics({ storeMetadata });
  const sliderRef = useRef<Slider>(null);
  const [testimonialType, setTestimonialType] = useState(config?.type);
  const [sliderLoad, setSliderLoad] = useState(false);

  const handleChangeType = useCallback((currentIndex: number) => {
    if ((document as any).startViewTransition) {
      (document as any).startViewTransition(() => {
        setTestimonialType(testimonials[currentIndex]?.type || "CUSTOMER");
      });
    } else {
      setTestimonialType(testimonials[currentIndex]?.type || "CUSTOMER");
    }
  }, []);

  const handleChange = (currentIndex: number) => {
    handleChangeType(currentIndex);
    logEvent(TESTIMONIAL_EVENTS.BUTTON, {
      user_type: "buyer",
      platform: "web",
      event_subtype: TESTIMONIAL_EVENTS.TESTIMONIALS,
    });
  };

  return {
    t,
    logEvent,
    sliderRef,
    testimonials,
    highLight: config?.highlight_background,
    testimonialType,
    sliderLoad,
    setSliderLoad,
    handleChange,
  };
};

export default useTestimonials;
